import { Box, Grid } from "@mui/material";
import type { ReactNode } from "react";

export type DashboardPageBodyProps = {
  children: ReactNode;
  /**
   * When true, fills viewport under the app bar (e.g. full-height monitor canvas).
   * Default is a normal flowing page.
   */
  fullHeight?: boolean;
  /**
   * When true (default), wraps children in a centered `Grid` with `size={12}`.
   * Set false when the page supplies its own grid (e.g. centered narrow columns).
   */
  centeredGrid?: boolean;
  /**
   * When true with `fullHeight`, removes default vertical margins so the child can
   * span edge-to-edge like a full-screen tool (e.g. Gemini-style chat).
   */
  flush?: boolean;
};

/** Uniform spacing below `DashboardNavbar` and outer grid for all dashboard routes. */
function DashboardPageBody({
  children,
  fullHeight: _fullHeight = false,
  centeredGrid = true,
  flush: _flush = false,
}: DashboardPageBodyProps) {
  return (
    <Box
      component="main"
      sx={{
        width: "100%",
        minWidth: 0,
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        mt: 0,
        mb: 0,
      }}
    >
      {centeredGrid ? (
        <Grid
          container
          spacing={0}
          sx={{
            width: "100%",
            m: 0,
            flex: 1,
            minHeight: 0,
            height: "100%",
          }}
        >
          <Grid
            size={12}
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              height: "100%",
            }}
          >
            {children}
          </Grid>
        </Grid>
      ) : (
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", height: "100%" }}>
          {children}
        </Box>
      )}
    </Box>
  );
}

export default DashboardPageBody;
